import { parseAlternatives, parseAnswersGTM, QuestionIdentifierType } from "../common";

// LOAD WELCOME SCREEN
export const AdviserHasOpenedGTM = (window: any) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event' : 'load',
    'event_category': 'recomendador - apertura',
    'event_action': 'info', 
    'event_label': 'carga',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 0 - apertura'
  });
}

// CLICK TO START
export const StartButtonGTM = (window: any) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'event' : 'click_to_action',
    'event_category': 'recomendador - apertura',
    'event_action': 'cilck_to_action', 
    'event_label': 'Comenzar',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 0 - apertura'
  });
}

// LOAD SERVICES TYPE SCREEN (QUESTION 1)
export const ServicesTypeScreenUploadedGTM = (window: any) => {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    'event' : 'load',
    'event_category': 'recomendador - servicios',
    'event_action': 'info', 
    'event_label': 'carga',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 1 - servicios'
  });
}

// CHECKBOX ALTERNATIVES (QUESTION 1)
export const ServiceTypeAlternativeSelectedGTM = (window: any, questionIdentifier: QuestionIdentifierType, title: string) => {
  window.dataLayer = window.dataLayer || []
  const alternativeSelected = parseAlternatives(title, questionIdentifier);
  window.dataLayer.push({
    'event' : 'interaction',
    'event_category': 'recomendador - servicios',
    'event_action': 'interaction', 
    'event_label': alternativeSelected,
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 1 - servicios'
  });
}

// BACK AND NEXT BUTTONS (ALL QUESTIONS)
export const QuestionsButtonGTM = (window: any, textButton: string, questionIdentifier: any, answers: any) => {
  window.dataLayer = window.dataLayer || [];
  let screenValue = "";
  let eventCategory = "";
  let valueGTM:any = "";

  if (questionIdentifier === "question_1") {
    screenValue = "paso 1 - servicios";
    eventCategory = "recomendador - servicios";
    valueGTM = parseAnswersGTM(answers, questionIdentifier);
    window.sessionStorage.removeItem("q1");
    window.sessionStorage.setItem("q1", valueGTM);
  }

  if (questionIdentifier === "question_2") {
    screenValue = "paso 2 - acceso";
    eventCategory = "recomendador - acceso";
    valueGTM = parseAnswersGTM(answers, questionIdentifier);
    window.sessionStorage.removeItem("q2");
    window.sessionStorage.setItem("q2", valueGTM);
  }

  if (questionIdentifier === "question_3") {
    screenValue = "paso 3 - seguridad";
    eventCategory = "recomendador - seguridad";
    valueGTM = parseAnswersGTM(answers, questionIdentifier);
    window.sessionStorage.removeItem("q3");
    window.sessionStorage.setItem("q3", valueGTM);
    window.sessionStorage.removeItem("q4");
  }

  if (questionIdentifier === "question_4") {
    screenValue = "paso 4 - licencias";
    eventCategory = "recomendador - licencias";
    valueGTM = parseAnswersGTM(answers, questionIdentifier);
    window.sessionStorage.setItem("q4", valueGTM);
  }
  
  let obj: any = {
    'event' : 'click_to_action',
    'event_category': `${eventCategory}`,
    'event_action': 'cilck_to_action',
    'eventLabel': textButton,
    'origen': 'entel.cl',
    'segment': 'ti',
    'market': 'emp',
    'page_owner': 'recomendador',
  };

  if (questionIdentifier === "question_1") {
    obj['description'] = valueGTM;
    obj['form_step_name'] = screenValue;
  }

  if (questionIdentifier === "question_2") {
    obj['variant_1'] = valueGTM;
    if (sessionStorage.getItem("q1")) {
      obj['description'] = sessionStorage.getItem("q1");
    }
    obj['form_step_name'] = screenValue;
  }

  if (questionIdentifier === "question_3") {
    obj['variant_2'] = valueGTM;
    if (sessionStorage.getItem("q2")) {
      obj['variant_1'] = sessionStorage.getItem("q2");
    }
    if (sessionStorage.getItem("q1")) {
      obj['description'] = sessionStorage.getItem("q1");
    }
    obj['form_step_name'] = screenValue;
  }

  if (questionIdentifier === "question_4") {
    obj['variant_3'] = valueGTM;
    if (sessionStorage.getItem("q3")) {
      obj['variant_2'] = sessionStorage.getItem("q3");
    }
    if (sessionStorage.getItem("q2")) {
      obj['variant_1'] = sessionStorage.getItem("q2");
    }
    if (sessionStorage.getItem("q1")) {
      obj['description'] = sessionStorage.getItem("q1");
    }
    obj['form_step_name'] = screenValue;
  }

  window.dataLayer.push(obj);
}

// CHECKBOX ALTERNATIVES (QUESTION 2)
export const AccessTypeAlternativeSelectedGTM = (window: any, questionIdentifier: QuestionIdentifierType, title: string) => {
  window.dataLayer = window.dataLayer || []
  const alternativeSelected = parseAlternatives(title, questionIdentifier);
  let obj: any = {
    'event' : 'interaction',
    'event_category': 'recomendador - acceso',
    'event_action': 'interaction', 
    'event_label': alternativeSelected,
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 2 - acceso',
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }
  window.dataLayer.push(obj);
}

// CHECKBOX ALTERNATIVES (QUESTION 3)
export const SecurityTypeAlternativeSelectedGTM = (window: any, questionIdentifier: QuestionIdentifierType, title: string) => {
  window.dataLayer = window.dataLayer || []
  const alternativeSelected = parseAlternatives(title, questionIdentifier);
  let obj: any = {
    'event' : 'interaction',
    'event_category': 'recomendador - seguridad',
    'event_action': 'interaction', 
    'event_label': alternativeSelected,
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 3 - seguridad',
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }
  if (sessionStorage.getItem("q2")) {
    obj['variant_1'] = sessionStorage.getItem("q2");
  }
  window.dataLayer.push(obj);
}

// CHECKBOX ALTERNATIVES (QUESTION 4)
export const LicenseTypeAlternativeSelectedGTM = (window: any, questionIdentifier: QuestionIdentifierType, title: string) => {
  window.dataLayer = window.dataLayer || []
  const alternativeSelected = parseAlternatives(title, questionIdentifier);
  let obj: any = {
    'event' : 'interaction',
    'event_category': 'recomendador - licencias',
    'event_action': 'interaction', 
    'event_label': alternativeSelected,
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 4 - licencias',
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }

  if (sessionStorage.getItem("q2")) {
    obj['variant_1'] = sessionStorage.getItem("q2");
  }

  if (sessionStorage.getItem("q3")) {
    obj['variant_2'] = sessionStorage.getItem("q3");
  }
  window.dataLayer.push(obj);
}

// LOAD ACCESS TYPE SCREEN (QUESTION 2)
export const AccessTypeScreenUploadedGTM = (window: any) => {
  window.dataLayer = window.dataLayer || []
  let obj: any = {
    'event' : 'load',
    'event_category': 'recomendador - acceso',
    'event_action': 'info', 
    'event_label': 'carga',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 2 - acceso'
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }

  window.dataLayer.push(obj);
}

// LOAD SECURITY TYPE SCREEN (QUESTION 3)
export const SecurityTypeScreenUploadedGTM = (window: any) => {
  window.dataLayer = window.dataLayer || []
  let obj: any = {
    'event' : 'load',
    'event_category': 'recomendador - seguridad',
    'event_action': 'info', 
    'event_label': 'carga',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 3 - seguridad'
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }

  if (sessionStorage.getItem("q2")) {
    obj['variant_1'] = sessionStorage.getItem("q2");
  }

  window.dataLayer.push(obj);
}

// LOAD LICENSE TYPE SCREEN (QUESTION 4)
export const LicenseTypeScreenUploadedGTM = (window: any) => {
  window.dataLayer = window.dataLayer || []
  let obj: any = {
    'event' : 'load',
    'event_category': 'recomendador - licencias',
    'event_action': 'info', 
    'event_label': 'carga',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 4 - licencias'
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }

  if (sessionStorage.getItem("q2")) {
    obj['variant_1'] = sessionStorage.getItem("q2");
  }

  if (sessionStorage.getItem("q3")) {
    obj['variant_2'] = sessionStorage.getItem("q3");
  }

  window.dataLayer.push(obj);
}

// LOAD CONTACT SCREEN (FORM)
export const ContactScreenUploadedGTM = (window: any) => {
  window.dataLayer = window.dataLayer || []
  let obj: any = {
    'event' : 'load',
    'event_category': 'recomendador - datos cliente',
    'event_action': 'info', 
    'event_label': 'carga',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 5 - datos cliente'
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }

  if (sessionStorage.getItem("q2")) {
    obj['variant_1'] = sessionStorage.getItem("q2");
  }

  if (sessionStorage.getItem("q3")) {
    obj['variant_2'] = sessionStorage.getItem("q3");
  }

  if (sessionStorage.getItem("q4")) {
    obj['variant_3'] = sessionStorage.getItem("q4");
  }

  window.dataLayer.push(obj);
}

// ACCEPT POLICIES
export const PolicyAcceptedGTM = (window: any) => {
  window.dataLayer = window.dataLayer || []
  let obj: any = {
    'event' : 'interaction',
    'event_category': 'recomendador - ultimo paso',
    'event_action': 'interaction', 
    'event_label': 'acepto las politicas',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 5 - datos cliente',
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }

  if (sessionStorage.getItem("q2")) {
    obj['variant_1'] = sessionStorage.getItem("q2");
  }

  if (sessionStorage.getItem("q3")) {
    obj['variant_2'] = sessionStorage.getItem("q3");
  }

  if (sessionStorage.getItem("q4")) {
    obj['variant_3'] = sessionStorage.getItem("q4");
  }

  window.dataLayer.push(obj);
}

// READ POLICIES
export const PolicyReadGTM = (window: any) => {
  window.dataLayer = window.dataLayer || []
  let obj: any = {
    'event' : 'go_to',
    'event_category': 'recomendador - datos cliente',
    'event_action': 'go_to', 
    'event_label': 'acepto las politicas',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp',
    'page_owner': 'recomendador',
    'form_step_name': 'paso 5 - datos cliente',
  };

  window.dataLayer.push(obj);
}

// SEND CONTACT DATA
export const SendContactDataGTM = (window: any, contactData: any) => {
  window.dataLayer = window.dataLayer || []
  let obj: any = {
    'event' : 'click_to_action',
    'event_category': 'recomendador - datos cliente',
    'event_action': 'click_to_action',
    'event_label': 'quiero continuar',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp',
    'page_owner': 'recomendador',
    'form_step_name': 'paso 5 - datos cliente',
    'name': btoa(contactData.name),
    'email': btoa(contactData.email),
    'phone_client': btoa(contactData.phone),
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }

  if (sessionStorage.getItem("q2")) {
    obj['variant_1'] = sessionStorage.getItem("q2");
  }

  if (sessionStorage.getItem("q3")) {
    obj['variant_2'] = sessionStorage.getItem("q3");
  }

  if (sessionStorage.getItem("q4")) {
    obj['variant_3'] = sessionStorage.getItem("q4");
  }
  window.dataLayer.push(obj);
}

// LOAD RECOMMENDATION SCREEN
export const RecommendationScreenUploadedGTM = (window: any, contactData: any) => {
  window.dataLayer = window.dataLayer || []
  let obj: any = {
    'event' : 'load',
    'event_category': 'recomendador - plan recomendado',
    'event_action': 'info', 
    'event_label': 'carga',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp', 
    'page_owner': 'recomendador',
    'form_step_name': 'paso 6 - plan recomendado',
    'name': btoa(contactData.name),
    'email': btoa(contactData.email),
    'phone_client': btoa(contactData.phone),
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }

  if (sessionStorage.getItem("q2")) {
    obj['variant_1'] = sessionStorage.getItem("q2");
  }

  if (sessionStorage.getItem("q3")) {
    obj['variant_2'] = sessionStorage.getItem("q3");
  }

  if (sessionStorage.getItem("q4")) {
    obj['variant_3'] = sessionStorage.getItem("q4");
  }

  window.dataLayer.push(obj);
}

// SEND RECOMMENDATION DATA
export const SelectRecommendationGTM = (window: any, contactData: any) => {
  window.dataLayer = window.dataLayer || []
  let obj: any = {
    'event' : 'click_to_action',
    'event_category': 'recomendador - plan recomendado',
    'event_action': 'click_to_action',
    'event_label': 'quiero contratar',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp',
    'page_owner': 'recomendador',
    'form_step_name': 'paso 6 - plan recomendado',
    'name': btoa(contactData.name),
    'email': btoa(contactData.email),
    'phone_client': btoa(contactData.phone),
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }

  if (sessionStorage.getItem("q2")) {
    obj['variant_1'] = sessionStorage.getItem("q2");
  }

  if (sessionStorage.getItem("q3")) {
    obj['variant_2'] = sessionStorage.getItem("q3");
  }

  if (sessionStorage.getItem("q4")) {
    obj['variant_3'] = sessionStorage.getItem("q4");
  }
  window.dataLayer.push(obj);
}

// START AGAIN
export const StartAgainGTM = (window: any, contactData: any) => {
  window.dataLayer = window.dataLayer || []
  let obj: any = {
    'event' : 'click_to_action',
    'event_category': 'recomendador - plan recomendado',
    'event_action': 'click_to_action',
    'event_label': 'volver a empezar',
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp',
    'page_owner': 'recomendador',
    'form_step_name': 'paso 6 - plan recomendado',
    'name': btoa(contactData.name),
    'email': btoa(contactData.email),
    'phone_client': btoa(contactData.phone),
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }

  if (sessionStorage.getItem("q2")) {
    obj['variant_1'] = sessionStorage.getItem("q2");
  }

  if (sessionStorage.getItem("q3")) {
    obj['variant_2'] = sessionStorage.getItem("q3");
  }

  if (sessionStorage.getItem("q4")) {
    obj['variant_3'] = sessionStorage.getItem("q4");
  }
  window.dataLayer.push(obj);
}

// SELECT RATE
export const SelectRateGTM = (window: any, contactData: any, rate: number) => {
  window.dataLayer = window.dataLayer || []
  let obj: any = {
    'event' : 'interaction',
    'event_category': 'recomendador - plan recomendado',
    'event_action': 'interaction',
    'event_label': `${rate}`,
    'origen': 'entel.cl',
    'segment': 'ti', 
    'market': 'emp',
    'page_owner': 'recomendador',
    'form_step_name': 'paso 6 - plan recomendado',
    'name': btoa(contactData.name),
    'email': btoa(contactData.email),
    'phone_client': btoa(contactData.phone),
  };

  if (sessionStorage.getItem("q1")) {
    obj['description'] = sessionStorage.getItem("q1");
  }

  if (sessionStorage.getItem("q2")) {
    obj['variant_1'] = sessionStorage.getItem("q2");
  }

  if (sessionStorage.getItem("q3")) {
    obj['variant_2'] = sessionStorage.getItem("q3");
  }

  if (sessionStorage.getItem("q4")) {
    obj['variant_3'] = sessionStorage.getItem("q4");
  }
  window.dataLayer.push(obj);
}